import React from "react";

export const About = (props) => {
  return (
    <div id="about">
      <div className="container">
        <div className="row">
          <div className="col-xs-12 col-md-12">
            <div className="about-text">
              <h2>About Us</h2>
              {props.data && props.data.paragraphs ? props.data.paragraphs.map((txt, i) => <p key={i}>{txt}</p>) : "Loading..."}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
